export function getCookie(cookieName:string) {
    let cookie:any = {};
    document.cookie.split(';').forEach(function(el) {
      let [ key, value ]:string[] = el.split('=');
      cookie[key.trim()] = value;
    })
    return cookie[cookieName];
}